import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LayoutDashboard,
  Package,
  ShoppingCart,
  Boxes,
  Store,
  Settings,
  Users,
  FileText,
  RefreshCw,
  Truck,
  Warehouse,
  Zap,
  FileBarChart,
  ArrowRightLeft,
  Copy,
  Shield,
  DollarSign,
  ToggleLeft,
  Globe,
  Upload,
  Sparkles,
  Activity,
  Database,
  Image,
  ImagePlus,
  FileCode,
  ListChecks,
  BarChart3,
  Radar,
  Inbox,
  GitCompare,
  Send,
  Eye,
  Tags,
  ListX,
} from 'lucide-react';

interface MenuItem {
  href: string;
  label: string;
  icon: React.ReactNode;
  adminOnly?: boolean;
}

const menuItems: MenuItem[] = [
  { href: '/', label: 'ダッシュボード', icon: <LayoutDashboard size={20} /> },
  { href: '/orders', label: '受注管理', icon: <ShoppingCart size={20} /> },
  { href: '/sales-dashboard', label: '売上ダッシュボード', icon: <BarChart3 size={20} /> },
  { href: '/inventory', label: '在庫管理', icon: <Boxes size={20} /> },
  { href: '/products', label: '商品管理', icon: <Package size={20} /> },
  { href: '/purchase-orders', label: '発注・仕入れ', icon: <FileBarChart size={20} /> },
  { href: '/shops', label: '店舗連携', icon: <Store size={20} /> },
  { href: '/wms', label: 'WMS連携', icon: <Warehouse size={20} /> },
  { href: '/shipping-labels', label: '送り状発行', icon: <Truck size={20} /> },
  { href: '/dropship', label: '楽天→Amazon転送', icon: <ArrowRightLeft size={20} /> },
  { href: '/amazon-to-rakuten', label: 'Amazon→楽天出品', icon: <Copy size={20} /> },
  { href: '/product-filters', label: 'NGフィルタ・文言管理', icon: <Shield size={20} /> },
  { href: '/pricing-settings', label: '価格設定・同意文', icon: <DollarSign size={20} /> },
  { href: '/site-masters', label: 'サイトマスタ管理', icon: <Database size={20} /> },
  { href: '/banners', label: '説明文バナー管理', icon: <Image size={20} /> },
  { href: '/image-selection-rules', label: '画像選定ルール', icon: <ImagePlus size={20} /> },
  { href: '/prompt-templates', label: 'プロンプトテンプレート', icon: <FileCode size={20} /> },
  { href: '/listing-flags', label: '出品フラグ管理', icon: <ToggleLeft size={20} /> },
  { href: '/rakuten-visibility', label: '楽天 公開/非公開管理', icon: <Eye size={20} /> },
  { href: '/brand-mall-summary', label: 'ブランド別 出品状況', icon: <Tags size={20} /> },
  { href: '/ebay-listing', label: 'eBay出品コントロール', icon: <Send size={20} /> },
  { href: '/seo', label: 'SEO最適化', icon: <Sparkles size={20} /> },
  { href: '/overseas-sourcing', label: '海外ECソーシング', icon: <Globe size={20} /> },
  { href: '/import-csv', label: '商品CSVインポート', icon: <Upload size={20} /> },
  { href: '/pipeline', label: '処理状況', icon: <Activity size={20} /> },
  { href: '/review-queue', label: '審査キュー', icon: <ListChecks size={20} /> },
  { href: '/pipeline-metrics', label: 'パイプライン指標', icon: <BarChart3 size={20} /> },
  { href: '/rakuten-sync-monitor', label: '楽天反映監視', icon: <Radar size={20} /> },
  { href: '/scraping-ingest-monitor', label: 'スクレイピング取り込み状況', icon: <Inbox size={20} /> },
  { href: '/source-compare', label: '仕入元比較', icon: <GitCompare size={20} /> },
  { href: '/automation', label: '自動化', icon: <Zap size={20} /> },
  { href: '/sync', label: '同期設定', icon: <RefreshCw size={20} /> },
  { href: '/reports', label: 'レポート', icon: <FileText size={20} /> },
  { href: '/cost-defects', label: '原価なし不備一覧', icon: <ListX size={20} />, adminOnly: true },
  { href: '/admin/users', label: 'ユーザー管理', icon: <Users size={20} />, adminOnly: true },
  { href: '/settings', label: '設定', icon: <Settings size={20} /> },
];

export default function Sidebar() {
  const { user } = useAuth();

  const filteredMenuItems = menuItems.filter(
    (item) => !item.adminOnly || user?.role === 'admin'
  );

  return (
    <aside
      className="w-[200px] h-screen fixed left-0 top-0 flex flex-col"
      style={{
        backgroundColor: 'var(--background-aside-primary)',
        color: 'var(--aside-text-color)',
      }}
    >
      {/* ロゴ */}
      <div className="p-4 flex items-center gap-2 border-b border-white/10">
        <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
          <Boxes size={20} className="text-white" />
        </div>
        <div>
          <div className="font-bold text-sm">在庫連動</div>
          <div className="text-xs opacity-75">システム</div>
        </div>
      </div>

      {/* メニュー */}
      <nav className="flex-1 py-4 overflow-y-auto">
        {filteredMenuItems.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            end={item.href === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                isActive
                  ? 'bg-white/20 border-l-4 border-white'
                  : 'hover:bg-white/10 border-l-4 border-transparent'
              }`
            }
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* フッター */}
      <div className="p-4 text-xs opacity-50 border-t border-white/10">
        v1.0.0
      </div>
    </aside>
  );
}

